module.exports = __webpack_public_path__ + "img/hvac_big.8bdcb2f2.png";